import { forwardRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { RECAPTCHA_SITE_KEY } from '../api/apiConfig';

interface RecaptchaCheckboxProps {
  onChange: (token: string | null) => void;
  disabled?: boolean;
}

const RecaptchaCheckbox = forwardRef<ReCAPTCHA, RecaptchaCheckboxProps>(
  ({ onChange, disabled = false }, ref) => {
    const siteKey = RECAPTCHA_SITE_KEY;

    if (!siteKey) {
      console.error('RECAPTCHA_SITE_KEY is not configured.');

      return (
        <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
          CAPTCHA is currently unavailable.
        </div>
      );
    }

    return (
      <div
        className={
          disabled
            ? 'pointer-events-none opacity-60'
            : ''
        }
      >
        <ReCAPTCHA
          ref={ref}
          sitekey={siteKey}
          onChange={onChange}
          onExpired={() => onChange(null)}
          onErrored={() => onChange(null)}
        />
      </div>
    );
  }
);

RecaptchaCheckbox.displayName = 'RecaptchaCheckbox';

export default RecaptchaCheckbox;